import styled, { css } from 'styled-components'

export const SimpleCheckboxContentsContainer = styled.label<{ disabled?: boolean }>`
    ${({ disabled, theme }) => css`
        cursor: ${disabled ? 'not-allowed' : 'default'};
        path {
            fill: ${disabled ? theme.color.text.disabled : ''};
        }
        & span {
            color: ${disabled ? theme.color.text.disabled : ''};
        }
    `}
    display: flex;
    justify-content: space-between;
`
